<!--开票申请-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <!-- <el-button icon="el-icon-plus" @click="add()">新增</el-button> -->
          <el-button icon="el-icon-upload2" @click="downloadExcel()">导出</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        border
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
           <el-button type="text" size="mini" icon="el-icon-view" @click="view(scope.row)"></el-button>
          <el-button type="text" size="mini" icon="el-icon-edit" v-if="statusEdit(scope.row.billState)" @click="edit(scope.row)"></el-button>
            <!-- <el-popover
            :ref="scope.row.billState"
            placement="top"
            width="220"
            v-if="scope.row.billState === 2"
          >
            <p>确定退回该开票单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.billState].doClose()">取消</el-button>
               <el-button type="primary" size="mini" @click="reject(scope.row)">退回</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-back" slot="reference"></el-button>
          </el-popover> -->
          <!-- <el-popover
            :ref="scope.row.billState"
            placement="top"
            width="180"
             v-if="statusUnAudit(scope.row.billState)"
          >
            <p>确定反审核该收款单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.billState].doClose()">取消</el-button>
               <el-button type="primary" size="mini" @click="reject(scope.row, 5)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-circle-close" slot="reference"></el-button>
          </el-popover> -->
          <el-popover :ref="scope.row.id" placement="top" width="180" v-if="statusEdit(scope.row.billState)">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button type="primary" size="mini" @click="subDelete(scope.row.id)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { delInvoice,aduitInvoice } from "@/api/bill/receipt";
import {tableSataus} from '@/views/bill/mixins/status'
import { downloadExcel } from "@/api/bill/ProjectPlan";
export default {
  name: "PartnerBudgetTask",
  components: {
    DynamicSearch
  },
  mixins: [DataTableMixin,tableSataus],
  data() {
    return {
      tableHead: [
         {
          label: "申请人",
          prop: "applyPersonName"
        },
         {
          label: "合同名称",
          prop: "contractName"
        },
        {
          label: "抬头",
          prop: "title",
            query: {
            type: "input"
          },
        },
        {
          label: "金额",
          prop: "money"
        },
        {
          label: "开票内容",
          prop: "content"
        },
         {
          label: "状态",
          prop: "billState",
            formatter: (state) => {
              return this.statusName(state)
            }
        }
      ]
    };
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
  },
  methods: {
     // 导出
      downloadExcel() {
      //   const obj = Object.keys(this._query)
      // const query = {customer: this._query[obj[0]],state: this._query[obj[1]]}
        downloadExcel('/invoicing/exportinvoicingApplyExcel',this._query,'开票申请')
      },
    dataTableBeforeInit() {
      this._url = "/invoicing";
      const params = { page: this.page, size: this.offset};
      this._params = Object.assign(params, this._query);
      return true;
    },
    dynamicSearch() {},
     view(row) {
      // this.$router.push({path: "invoice/form" ,query: { id: row.id,isEdit: 0}});
       this.$router.push({name: "InvoiceForm" ,params: { id: row.id,isEdit: 0 }})
    },
    // 新增
    add() {
      //  this.$router.push({path: "invoice/form" ,query: {isEdit: 1}});
       this.$router.push({name: "InvoiceForm"})
    },
    edit(row) {
      // this.$router.push({path: "/finance/invoice/form" ,query: { id: row.id,isEdit: 1}});
      this.$router.push({name: "InvoiceForm" ,params: { id: row.id,isEdit: 1 }})
    },
    audit(data) { // 审核
      this.updata({id: data.id,billState: 3});
      this.$refs[data.billState].doClose()
    },
    // 4退回 5 反审核
    reject(data, status = 4) {
      this.updata({id: data.id, billState: status});
      this.$refs[data.billState].doClose()
    },
    updata(data) {
      aduitInvoice(data).then(res => {
        if (res.code === 200) {
          this.$notify({
            title: '操作成功',
            type: "success",
            duration: 2500
          });
           this.dataTableInit();
        }
      });
    },
    // 删除
    subDelete(id) {
      delInvoice(id).then(res => {
        console.log(res);
        this.dataTableInit();
        this.$notify({
          title: "删除成功",
          type: "success",
          duration: 2500
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
</style>
